import Vue from 'vue'
import vuex from 'vuex'
import System from './system'
Vue.use(vuex)

export default new vuex.Store({
  modules: {
    system: System
  }
})
